module.exports = __webpack_public_path__ + "media/assets/images/landings/kitchen/front_schermo-1c1144cdb544611cdcb96179d972208a.png";